import { ConfidentialityMode } from '@dreryk/egabinet-personnel-frontend-api';

import { useGetCurrentPractitionerGlobalState } from './useGetCurrentPractitionerGlobalState';

export const useCurrentPractitionerConfidentialityMode = (): ConfidentialityMode => {
   const currentPractitioner = useGetCurrentPractitionerGlobalState();

   return currentPractitioner?.confidentialityMode ?? 'NORMAL';
};
